import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import { sendResetMail } from '../actions/Users';
import { ReactComponent as EpikLogoSvg } from '../Res/granite-logo.svg';
import './login.css';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      message: '',
      showResult: false,
      blockedMessage:
        "Password reset isn’t available for this login. Please contact your Granite account manager for access.",
    };
  }

  handleChange = e => {
    this.setState({ email: e.target.value.trim() });
  };

  handleSubmit = async e => {
   const messageError=`If an account exists for this email address, a password reset link will be sent. Please check your inbox and spam folder.`
    const { sendResetMail } = this.props;
    const { email, blockedMessage } = this.state;
    e.preventDefault();
    try {
      await sendResetMail(email);
      localStorage.setItem('email', email);
      this.setState({
        message:messageError,
        showResult: true,
      });
    } catch (error) {
      const apiMessage = error.message || '';

      if (apiMessage === blockedMessage) {
        this.setState({
          message: blockedMessage,
          showResult: true,
        });
      } else {
        this.setState({
          message:messageError,
          showResult: true,
        });
      }
    }
  };

  handleBack = () => {
    this.setState({
      message: '',
      showResult: false,
    });
  };

  render() {
    const { user } = this.props;
    const { message, email, showResult, blockedMessage } = this.state;
    if (user && user._id) {
      return <Redirect to="/" />;
    }

    return (
      <div className="container main-container">
        <div className="login-container">
          <div className="col-12 align-self-start" style={{ display: 'flex' }}>
            <EpikLogoSvg width={120} height={60} />
          </div>
          <div className="col-12 text-left" style={{ marginTop: '30px' }}>
            {showResult ? (
              message === blockedMessage ? (
                <>
                  <h5>Password reset isn’t available for this login.</h5>
                  <p style={{ color: '#8998ac' }}>
                    Please contact your Granite account manager for access.{' '}
                    <Link
                      style={{ color: '#3b5aa9', textDecoration: 'underline' }}
                      to="/reset-password"
                      onClick={this.handleBack}
                    >
                      Try again
                    </Link>{' '}
                    or go back to{' '}
                    <Link
                      to="/login"
                      style={{ color: '#3b5aa9', textDecoration: 'underline' }}
                    >
                      login page.
                    </Link>
                  </p>
                </>
              ) : (
                <>
                  <h1 className="reset-title">Password Reset Request Received</h1>
                  <p className="reset-message">
                    {message}{' '}
                    <Link
                      to="/reset-password"
                      onClick={this.handleBack}
                      className="reset-link"
                    >
                      Try again
                    </Link>{' '}
                     or go back to{' '}
                    <Link to="/login" className="reset-link">
                     login page.
                    </Link>
                  </p>
                </>
              )
            ) : (
              <>
                <h5>Reset Password</h5>
                <p style={{ color: '#8998ac' }}>
                  Please enter your email address to search for your account and we will send you an
                  email to reset your password.
                </p>
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Input
                      className="input-field"
                      type="email"
                      value={email}
                      onChange={this.handleChange}
                      required
                      placeholder="Enter your email address"
                    />
                  </FormGroup>
                  <FormGroup className="text-right">
                    <Button color="primary" id="reset-search">
                      Search
                    </Button>
                    <Link to="/" style={{ marginLeft: '10px' }}>
                      <Button type="button" id="reset-cancel">
                        Cancel
                      </Button>
                    </Link>
                  </FormGroup>
                </Form>
              </>
            )}
          </div>
          {/* <div className="col-3" style={{ margin: "auto" }}>
              <img style={{ width: "300px" }} alt="Epik" src={EpikLogo} />
            </div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  sendResetMail: email => dispatch(sendResetMail(email)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPassword);
